import { CommonModule, DatePipe } from '@angular/common';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { PageService } from '../../../services/page-service';
import { BehaviorSubject, map, Subject, Subscription, switchMap } from 'rxjs';
import { TranslateModule, TranslateService } from '@ngx-translate/core'; 
import { Translatable } from '../../../models/translatable.model';
import { Page } from '../../../models/page.model';
import { PageSection, SectionFile } from '../../../models/page-section.model';
import { Media } from '../../../models/media.model';
import { LocalDatePipe } from '../../../shared/pipes/local-date-pipe';
import { LightboxComponent } from '../../../shared/components/lightbox/lightbox.component';
import { LightboxMedia } from '../../../shared/components/lightbox/lightbox.model';


@Component({
  selector: 'app-page-component',
  imports: [CommonModule, TranslateModule, LightboxComponent],
  providers: [DatePipe],
  templateUrl: './page-component.html',
  styleUrl: './page-component.css',
})
export class PageComponent implements OnInit,OnDestroy{
  private route = inject(ActivatedRoute);
  private pageService = inject(PageService);
  private sanitizer = inject(DomSanitizer);

  defaultImg:string ='/assets/images/page.png';
  pageSub$: Subscription = new Subscription();
  page$ =new BehaviorSubject<Page>({});
  /*page$ = this.route.paramMap.pipe(
    map(params => params.get('slug')),
    switchMap(slug => this.pageService.loadPageBySlug(slug!))
  );*/

   constructor(
    private translate: TranslateService,
    private datePipe: DatePipe,
  ) {}
  
  ngOnInit(): void {
    const slug:string = this.route.snapshot.paramMap.get('slug')!;
    if(slug){
      this.pageSub$ = this.pageService.loadPageBySlug(slug).subscribe({
      next: (value) => {
        //console.log('pqge ',value.data);
        this.page$.next (value.data);
      },
      error: (err) => {
        this.page$.next({});
        console.log('error ', err);
      },
    });
    }
    
  }


  ngOnDestroy(): void {
    this.pageSub$.unsubscribe();
  }
  formatDate(value: string): string {
      return this.datePipe.transform(value, 'dd MMM, yy', undefined, 'fr-FR') ?? '';
    }
  
    translateField(field: Translatable|null|undefined) {
      const lang = this.translate.getCurrentLang();
      //console.log('la is ',field);
      if(field){
        switch (lang) {
          case 'fr':
            return field.fr;
          case 'en':
            return field.en;
          case 'ar':
            return field.ar;
          default:
            return field.fr;
        }
      }else return '';
      
    }

    /**
     * Fond du bandeau d'en-tête.
     *
     * Renvoie l'image à la une quand elle est renseignée ; sinon `none`,
     * ce qui laisse s'appliquer le dégradé défini par .cuspage-hero__bg.
     */
    heroBackground(page: Page): SafeStyle | null {
      const url = page.featured_image?.url;

      // Sans image, on ne pose aucun style inline : `none` écraserait le
      // dégradé défini par .cuspage-hero__bg et le titre blanc deviendrait
      // illisible sur fond clair.
      if (!url) {
        return null;
      }

      return this.sanitizer.bypassSecurityTrustStyle(`url('${url}')`);
    }

    // ── Visionneuse des sections « galerie » ────────────────────────
    lightboxOpen  = false;
    lightboxIndex = 0;
    lightboxMedia: LightboxMedia[] = [];

    /** Ouvre la visionneuse sur les médias de la section cliquée. */
    openLightbox(items: any[] | null | undefined, index: number): void {
      this.lightboxMedia = (items ?? []).map((m: any) => ({
        url:  m?.url ?? '',
        type: m?.type,
      }));
      this.lightboxIndex = index;
      this.lightboxOpen  = true;
    }

    /** Sections visibles, triées par ordre d'affichage. */
    sectionsOf(page: Page): PageSection[] {
      return (page.sections ?? []).slice().sort((a, b) => a.order - b.order);
    }

    /** Vrai si la section porte un titre dans la langue courante. */
    hasTitle(section: PageSection): boolean {
      return !!this.translateField(section.title);
    }

    /** Libellé du bouton de téléchargement, avec type et taille. */
    fileMeta(file: SectionFile): string {
      return [file.type, file.size].filter(Boolean).join(' · ');
    }

    /** Identité de suivi pour *ngFor, afin d'éviter les re-rendus inutiles. */
    trackSection(_: number, section: PageSection): number {
      return section.id;
    }

    trackFile(_: number, file: SectionFile): string {
      return file.slug;
    }

    loadImageFeatured(imageUrl:Media|null|undefined){
      return (imageUrl)?imageUrl.url:"/assets/images/default_image.png";
    }
}
